module.exports = new __parcel__URL__("ts.fb5e018d.png").toString();